import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { EditConnections } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface EditConnectionAction extends Action {
  dataConnectionsOrSources: IContentInfo[];
}

export function editDataConnections(dataConnectionsOrSources: IContentInfo[]): EditConnectionAction {
  return {
    type: EditConnections,
    dataConnectionsOrSources
  };
}

export const isEditDataConnectionAction = isActionFactory<EditConnectionAction>(EditConnections);
